import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { usePinnedViewLimit } from '../../viewLimits/hooks/usePinnedViewLimit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddViewButton = ({
  numberOfPinnedViews
}) => {
  const {
    data: pinnedViewsLimitData
  } = usePinnedViewLimit();
  const total = numberOfPinnedViews === undefined ? '--' : numberOfPinnedViews;
  const limit = pinnedViewsLimitData && pinnedViewsLimitData.toString() || '--';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(View, {
      as: "span",
      marginInline: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.pinnedViews.addView",
        options: {
          total,
          limit
        }
      })
    })]
  });
};